module.exports = __webpack_public_path__ + "static/media/happy_birthday_small.a9d60f97.svg";